import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { trackMenuClickUserAction } from '../../../../../../common/analytics/menu/MenuUserAction';
import { Link } from '../../../../../../components/Link/Link';
import { Size } from '../../../../../../constants/styles';
const List = styled.ul `
  list-style: none;
  display: flex;
  flex-direction: column;

  li {
    white-space: nowrap;
  }
`;
const StyledLink = styled(Link) `
  text-decoration: none;
  line-height: 34px;
  font-size: ${Size.body15};
  font-weight: 300;

  &:hover {
    text-decoration: underline;
  }
`;
export const LinksList = ({ links, panelTitle, columnTitle, className }) => (_jsx(List, Object.assign({ className: className }, { children: links.map((link) => (_jsx("li", { children: _jsx(StyledLink, Object.assign({ href: link.url, onClick: (event) => trackMenuClickUserAction({
                event,
                panelTitle,
                linkName: link.name,
                columnTitle,
                elementType: 'Link',
            }) }, { children: link.name }), void 0) }, link.url))) }), void 0));
//# sourceMappingURL=LinksList.js.map